import { AppBar, Box, Hidden, IconButton, List, ListItem, ListItemIcon, ListItemText, Toolbar } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import { MdArrowBack } from "react-icons/md";
import PoolDetailStyle from "./DetailsStyle";
import { useHistory } from "react-router";

type Title = {
    text: string;
    id: string;
}

type DynamicVerticalMenuProps = {
    titles: Title[]
}

const DynamicVerticalMenu: FC<any> = ({ titles }: DynamicVerticalMenuProps) => {

    const classes = PoolDetailStyle();
    const history = useHistory();

    const headerHeight = 80;

    const handleClick = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            const elementTop = element.getBoundingClientRect().top + window.scrollY; // Get the top position relative to the page
    
            // Scroll to the element, considering the header offset
            window.scrollTo({
                top: elementTop - headerHeight,
                behavior: 'smooth',
            });
        }
    };

    const handleBack = (event: any) => {
        event.preventDefault();
        history.push('/deals');
    }

    return (
        <>
            <Hidden mdDown>
                <Box className={classes.navRoot}>
                    <List component="nav" aria-label="pool-detail">
                        <ListItem button className={classes.item} onClick={handleBack}>
                            <ListItemIcon style={{
                                minWidth: "12px",
                            }}>
                                <MdArrowBack />&nbsp;
                            </ListItemIcon>
                            <ListItemText primary="Go Back" className={classes.itemText} />
                        </ListItem>
                        {
                            titles.map((title: Title) => {
                                return (
                                    <ListItem button className={classes.item}>
                                        <ListItemText primary={title.text} className={classes.itemText} onClick={() => handleClick(title.id)}
                                            key={title.id} />
                                    </ListItem>
                                )
                            })
                        }
                    </List>
                </Box>
            </Hidden>
        </>
    )
}

export default DynamicVerticalMenu;